export default __webpack_public_path__ + "static/media/bg.37f03a9d.png";